import { z } from 'zod'
import { getDuplicatesRefinement } from 'src/util/src/zod'
import { ImageUrlSchema } from '../../Generic/models/ImageUrl'
import { IdSchema } from '../../Generic/models/Id'
import { TassetSchema } from '../../Finance/models/Tasset'

export const TokenSchema = z.object({
  id: IdSchema,
  asset: TassetSchema,
  tokenomics: z.array(ImageUrlSchema),
  tokenomicsAvailableAt: z.date().nullable(),
})

export const TokensSchema = z.array(TokenSchema)
  .superRefine(getDuplicatesRefinement('Token', parseTokenUid))

export const TokenUidSchema = TokenSchema.pick({
  id: true,
})

export type Token = z.infer<typeof TokenSchema>

export type TokenUid = z.infer<typeof TokenUidSchema>

export function parseToken(token: Token): Token {
  return TokenSchema.parse(token)
}

export function parseTokens(tokens: Token[]): Token[] {
  return TokensSchema.parse(tokens)
}

export function parseTokenUid(tokenUid: TokenUid): TokenUid {
  return TokenUidSchema.parse(tokenUid)
}
